import { Stack } from '@mui/material';
import EmailEditor, { EmailEditorProps } from 'react-email-editor';
import { useMemo, useEffect, useRef } from 'react';
import useContactColumns from 'hooks/queries/useContactColumns';
import { getUnlayerMergeTags } from 'utils';
import defaultDesign from './defaultDesign.json';

const DirectMailEditor = ({ editorRef, initialDesign, onEditorReady }: any) => {
    const { data: contactColumns, isSuccess: isContactColumnsSuccess } = useContactColumns();
    const lastLoadedDesignRef = useRef(null);

    const mergeTags = useMemo(() => {
        if (isContactColumnsSuccess) return getUnlayerMergeTags(contactColumns);
    }, [contactColumns, isContactColumnsSuccess]);

    const onLoad: EmailEditorProps['onLoad'] = (unlayer) => {
        const designToLoad = initialDesign ?? defaultDesign;
        // TODO: figure out types here - should be JSONTemplate but not sure how to access that
        // @ts-ignore
        unlayer.loadDesign(designToLoad);
        lastLoadedDesignRef.current = designToLoad;
    };

    const onReady: EmailEditorProps['onReady'] = (unlayer) => {
        // Editor is ready, notify parent and export default design
        if (onEditorReady) {
            // Give editor a moment to fully load the design, then export it
            setTimeout(() => {
                unlayer.exportHtml((data) => {
                    onEditorReady(data);
                });
            }, 100);
        }
    };

    // Handle design changes after initial load
    useEffect(() => {
        const unlayer = editorRef.current?.editor;
        if (unlayer && initialDesign && initialDesign !== lastLoadedDesignRef.current) {
            // @ts-ignore
            unlayer.loadDesign(initialDesign);
            lastLoadedDesignRef.current = initialDesign;
        }
    }, [initialDesign, editorRef]);

    return (
        <Stack height="100%" mt="20px">
            <EmailEditor
                ref={editorRef}
                onLoad={onLoad}
                onReady={onReady}
                options={{
                    appearance: {
                        panels: {
                            tools: {
                                dock: 'left',
                            },
                        },
                    },
                    features: { preview: false },
                    displayMode: 'document',
                    mergeTags,
                    // TODO: might need to create a separate workspace for this eventually
                    projectId: 3990,
                }}
            />
        </Stack>
    );
};

export default DirectMailEditor;
